/* eslint no-unneeded-ternary: 0 */
const isVisible = product => product.attributes.custom.manifest.visible === 1;

const hasEssentialProps = hiddenProducts => (product) => {

    const condition = product.attributes.custom.manifest.name &&
                    product.attributes.custom.manifest.os ?
        true :
        false;

    if (condition) {

        return true;

    }

    hiddenProducts.push(product);
    return false;

};

const hasUnsupportedBrowsers = (Util, $scope) => (product) => {

    const productManifest = product.attributes.custom.manifest;

    // browser not supported, remove extension from app list
    if (Util.deepFind(product, 'attributes.custom.manifest.browsers') &&
        productManifest.browsers.indexOf($scope.browserName) === -1) {

        return false;

    }

    return true;

};

export { isVisible, hasEssentialProps, hasUnsupportedBrowsers };




// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/products/productFilters.js